import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaskitoDirective } from '@maskito/angular';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerInputCalendarComponent } from '../../../../views/shared/components/form-components/datepicker-input/datepicker-input-calendar/datepicker-input-calendar.component';
import { DatepickerInputComponent } from '../../../../views/shared/components/form-components/datepicker-input/datepicker-input.component';

@Component({
  selector: 'app-table-header-date-input',
  standalone: true,
  imports: [AsyncPipe, MaskitoDirective, NgbPopover, DatepickerInputCalendarComponent],
  templateUrl: '../../../../views/shared/components/form-components/datepicker-input/datepicker-input.component.html',
  styleUrls: ['./table-header-date-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TableHeaderDateInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class TableHeaderDateInputComponent extends DatepickerInputComponent {
  @Input() placeholder: string = $localize`Select`;
  @Input() override placement: string | string[] = ['bottom-end', 'bottom-start', 'top-end', 'top-start'];

  protected override useShorthandDateDisplay = true;

  public onFocus(): void {
    super.onFocus();
    this.placeholder = 'DD/MM/YYYY';
  }

  public onBlur(): void {
    super.onBlur();
    this.placeholder = $localize`Select`;
  }
}
